import { useEffect, useState, useRef } from 'react';
import React from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios'
import { Nav, Tab, Form, Button } from 'react-bootstrap';

function AForm(props) {


    const [key, setKey] = useState('Agent Details');
    const [validated, setValidated] = useState(false);
    const fileRef = useRef();
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [agentFiles, setAgentFiles] = useState([]);

    const [formdata, setformdata] = useState(
        {   
            platform: 'livekit',
            voiceid: '',
            agentname: '',
            description: '',
            prompt :'',
            firstmessage: '',
            file: '',
            enable_calendar: false,
            cal_username: '',
            cal_event_type_slug: '',
            language: 'en'
        }
    )

    const [voices, setVoices] = useState([]);
    const [intentRows, setIntentRows] = useState([]);

    const INTENT_LABELS = {
        who_are_you:     'Who Are You?',
        not_interested:  'Not Interested',
        busy:            'Busy / Call Later',
        positive:        'Positive (Yes/Sure)',
        send_whatsapp:   'Send on WhatsApp',
        voicemail:       'Voicemail',
        give_email:      'Give Email',
        call_back:       'Call Me Back'
    };

    const DEFAULT_PATTERNS = {
        who_are_you:    'who.*this|who are you|which company|your name',
        not_interested: 'not interested|remove me|stop calling|dont call|not relevant',
        busy:           'busy|call.*later|bad time|not a good time',
        positive:       '^(yes|yeah|yep|sure|okay|ok|alright|go ahead)$',
        send_whatsapp:  'whatsapp|send.*details|send.*info|message me',
        voicemail:      'leave.*message|after.*beep|voicemail',
        give_email:     'send.*email|email me|mail me',
        call_back:      'call.*back|try.*again.*later|ring.*back'
    };

    const formTabs = [
        { name: 'Agent Details', fields:[ 'voiceid', 'agentname', 'description' ]},
        { name: 'Instructions', fields: [ 'prompt','firstmessage'] },
        { name: 'Knowledge Base', fields: ['file'] },
        { name: 'Actions', fields: [] },
        { name: 'Intent Responses', fields: [] }
    ]
    const fieldnames = formTabs.reduce((fields, tab) => { return [...fields, ...tab.fields] }, [])
    const placeholders = {
        // platform: 'Platform of your Voice Agent',
        agentname: 'Name of your Voice Agent',
        description: 'More information about this Agent',
        prompt: 'Give detailed instructions to the agent on how to sale your product',
        firstmessage: 'The first message that the assistant will say. Keep it short and engaging.',
        file: 'Knowldge base file (pdf,docx,txt)'
    }

    const createFormTemplate = async () => {

        // const request = {
        //     url: '/createformtemplate',
        //     data: { userid: props.uid, formdata: formdata },
        //     method: "POST"
        // }

        if (window.confirm(`Create Agent ${formdata.agentname}?`)) {

            let data = new FormData();

            for (const [key, val] of Object.entries(formdata))
                data.set(key, val);

            data.set('platform', 'livekit')
            data.set('createdby', props.uid);
            data.set('userid', props.uid || '');
            data.set('agentid', props.aid || '');
            data.set('targetPath', `knowledgebase_files/U${props.uid}/${props.aid || 'new'}`);

            // append all selected files
            if (fileRef.current && fileRef.current.files && fileRef.current.files.length > 0) {
                for (const file of Array.from(fileRef.current.files)) {
                    data.append('files', file);
                }
            }

            const response = await fetch('/api/voiceagent', {
                method: "POST",
                body: data,
                headers: { "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` }
            })

            if (response.ok)
                alert('Agent Created')
            else
                alert('Something wrong happened. Can you please try after some time?')

            props.disableCForm()
        }

    }

    const handleFilesChange = (e) => {
        const files = e.target.files ? Array.from(e.target.files) : [];
        setSelectedFiles(files);
    }

    const fetchAgentFiles = async () => {
        if (!props.aid) { setAgentFiles([]); return; }
        try {
            const resp = await fetch(`/api/voiceagent/files/${props.aid}`, { headers: { "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` } });
            if (resp.ok) {
                const data = await resp.json();
                setAgentFiles(data || []);
            }
        } catch (err) {
            console.log('Error fetching agent files', err);
        }
    }

    const deleteAgentFile = async (filename) => {
        if (!window.confirm(`Delete ${filename}?`)) return;
        try {
            const resp = await fetch('/api/voiceagent/file', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` },
                body: JSON.stringify({ agentid: props.aid, filename })
            });
            if (resp.ok) {
                fetchAgentFiles();
            } else {
                alert('Failed to delete file');
            }
        } catch (err) {
            console.log('Error deleting file', err);
        }
    }

    const fetchIntentResponses = async () => {
        if (!props.aid) { setIntentRows([]); return; }
        try {
            const resp = await fetch(`/api/voiceagentintents/${props.aid}`, { headers: { "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` } });
            if (resp.ok) {
                const data = await resp.json();
                setIntentRows(data || []);
            }
        } catch (err) {
            console.log('Error fetching intent responses', err);
        }
    }

    const saveIntentResponses = async () => {
        if (!props.aid) return;
        try {
            await fetch('/api/voiceagentintents', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` },
                body: JSON.stringify({ agentid: props.aid, intents: intentRows })
            });
        } catch (err) {
            console.log('Error saving intent responses', err);
        }
    }

    const addIntentRow = () => {
        setIntentRows(prev => [...prev, { intent: '', pattern: '', response: '', is_active: 1 }]);
    }

    const updateIntentRow = (idx, field, value) => {
        setIntentRows(prev => prev.map((row, i) => i === idx ? { ...row, [field]: value } : row));
    }

    const removeIntentRow = (idx) => {
        setIntentRows(prev => prev.filter((_, i) => i !== idx));
    }


    const modifyAgent = async () => {

        if (!window.confirm(`Modify agent ${formdata.agentname} with given details?`)) return;

        try {
            const data = new FormData();
            data.append('agentid', props.aid);
            data.append('createdby', props.uid);
            data.append('agentname', formdata.agentname || '');
            data.append('description', formdata.description || '');
            data.append('prompt', formdata.prompt || '');
            data.append('firstmessage', formdata.firstmessage || '');
            data.append('voiceid', formdata.voiceid || '');
            // Stringify because it gets sent as part of formdata object explicitly
            data.append('enable_calendar', !!formdata.enable_calendar);
            data.append('formdata', JSON.stringify(formdata));

            if (fileRef.current && fileRef.current.files && fileRef.current.files.length > 0) {
                for (const file of Array.from(fileRef.current.files)) {
                    data.append('files', file);
                }
            }

            const resp = await fetch('/api/updatevoiceagent', {
                method: 'POST',
                body: data,
                headers: { "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` }
            });

            if (!resp.ok) throw new Error('Update failed');

            alert('Agent Modified');
            await saveIntentResponses();
            setformdata({
                platform: 'livekit',
                voiceid: '',
                agentname: '',
                description: '',
                prompt: '',
                firstmessage: '',
                file: '',
                cal_username: '',
                cal_event_type_slug: '',
                language: ''
            });

            fetchAgentFiles();
            props.disableCForm();
        } catch (err) {
            console.error(err);
            alert('Server Error! Agent details NOT modified or files upload failed');
        }

    }

    const switchToTab = (key) => {
        setKey(key)
    }

    const handlefieldvalue = (field, value) => {
        setformdata(prevdata => ({
            ...prevdata,
            [field]: value
        }));
    }

    const validateFields = (form, fields) => {
        return fields.every(fieldName => form.elements[fieldName]?.checkValidity());
    };

    const findInvalidField = (form, fields) => {
        return fields.find(fieldName => form.elements[fieldName]?.checkValidity() == false)
    }
  
    const isFormTouched = (form, fields) => {
        return fields.some(fieldName => form.elements[fieldName]?.checkValidity());
    }

    const handleCancel = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget
        if (!isFormTouched(form, fieldnames)) {
            props.disableCForm()
        } else {
            if (window.confirm(`You have not saved the agent. Discard data?`)) {
                props.disableCForm()
            }
        }

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;

        let invalidTab = null;
        let fields = []
        let  firstInvalid = null
        for (const tab of formTabs) {
            if (!validateFields(form, tab.fields)) {
                invalidTab = tab.name;
                fields = tab.fields
                break;
            }
        }

        if (invalidTab) {
            switchToTab(invalidTab);  
            firstInvalid = document.getElementsByName(findInvalidField(form, fields))[0]
            setTimeout(() => {
                firstInvalid?.focus();
              }, 0);
        } else {
            props.modifymode ? modifyAgent() : createFormTemplate();
        }

        setValidated(true);
    };

    useEffect(() => {
        if (props.formdata && Object.keys(props.formdata).length > 0) {
            setformdata(props.formdata) 
        } else {
            setformdata({
                platform: 'livekit',
                voiceid: '',
                agentname: '',
                description: '',
                prompt :'',
                firstmessage: '',
                file: '',
                enable_calendar: false,
                cal_username: '',
                cal_event_type_slug: '',
                language: ''
            })
        }

    }, [props.formdata])

    useEffect(() => {
        fetchAgentFiles();
        fetchIntentResponses();
    }, [props.aid])


    useEffect(()=>{
        const date = new Date().toISOString().slice(0,10);;
        setformdata(prevState => ({
            ...prevState,
            'date': date
        }))
    },[])

    useEffect(()=>{
        let mounted = true;
        axios.get('/voiceagentvoices')
            .then(res => { if(mounted) setVoices(res.data || []) })
            .catch(err => { if(mounted) setVoices([]) });
        return () => { mounted = false }
    },[])

    return (
        <>
            <Container fluid>
                <Form noValidate validated={validated} onSubmit={handleSubmit} onReset={handleCancel}>
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav variant="underline">
                            <Nav.Link eventKey="Agent Details">Agent Details</Nav.Link>
                            <Nav.Link eventKey="Instructions">Instructions</Nav.Link>
                            <Nav.Link eventKey="Knowledge Base">Knowledge Base</Nav.Link>
                            <Nav.Link eventKey="Actions">Actions</Nav.Link>
                            <Nav.Link eventKey="Intent Responses">Intent Responses</Nav.Link>

                        </Nav>

                        <Tab.Content className="mt-3" style={{ height: "480px" }}>
                            <Tab.Pane eventKey="Agent Details">
                                
                                
                                    {/* <Row>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Platform</Form.Label>
                                            <Form.Control as="select" name='platform' disabled={props.modifymode} value={formdata.agentplatform} onChange={(e) => handlefieldvalue('platform', e.target.value)}>
                                                <option value="">Select Platform</option>
                                                <option value="livekit">Livekit</option>
                                                <option value="vapi">Vapi</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Row> */}
                                
                                    <Row>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Voice</Form.Label>
                                            <Form.Control as="select" name='voiceid' value={formdata.voiceid} onChange={(e) => handlefieldvalue('voiceid', e.target.value)}>
                                                <option value="">Select Voice</option>
                                                {voices.map(v=> (
                                                    <option key={v.id} value={v.id}>{v.name}</option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </Row>
                                
                                <Row>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Agent Name</Form.Label>
                                        <Form.Control required name='agentname' placeholder={placeholders.agentname} value={formdata.agentname} onChange={(e) => handlefieldvalue('agentname', e.target.value)} type="text" />
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Agent Description</Form.Label>
                                        <Form.Control required name='description' as="textarea" rows={2} placeholder={placeholders.description} value={formdata.description} onChange={(e) => handlefieldvalue('description', e.target.value)} />
                                    </Form.Group>
                                </Row>
                                <Row>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Language</Form.Label>
                                        <Form.Control as="select" name='language' value={formdata.language || 'en'} onChange={(e) => handlefieldvalue('language', e.target.value)}>
                                            <option value="en">English</option>
                                            <option value="hi">Hindi</option>
                                            <option value="mr">Marathi</option>
                                            <option value="ta">Tamil</option>
                                            <option value="te">Telugu</option>
                                            <option value="kn">Kannada</option>
                                        </Form.Control>
                                    </Form.Group>
                                </Row>
                                
                            </Tab.Pane>

                            <Tab.Pane eventKey="Instructions">
                                    <Row>
                                        <Col>
                                            <div className="mb-3 p-2" style={{border:'1px dashed #ccc', borderRadius:4, background:'#fbfbfb'}}>
                                                <strong>Dynamic Variables:</strong>
                                                <div style={{marginTop:2}}>
                                                    <code style={{marginRight:10}}>[Person_Name]</code>
                                                    <code style={{marginRight:10}}>[Company_Name]</code>
                                                    <code style={{marginRight:10}}>[Person_Role]</code>
                                                </div>
                                                
                                                <strong style={{marginTop:2}} className={"mt-6"}>Tools:</strong>
                                                <div style={{marginTop:2}}>
                                                    <code style={{marginRight:10}}>send_email</code>
                                                </div>
                                                {/* <div style={{marginTop:6, fontSize:12, color:'#444'}}>
                                                    Use these variables inside the <em>Prompt</em> or <em>First Message</em>. Using <strong>send_email</strong> tool agent can send email.
                                                </div> */}
                                            </div>

                                            <Form.Group className="mb-3" >
                                                <Form.Label>Prompt </Form.Label>
                                                <Form.Control required name='prompt' as="textarea" rows={10} placeholder={placeholders.prompt} value={formdata.prompt} onChange={(e) => handlefieldvalue('prompt', e.target.value)} />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group className="mb-3" >
                                                <Form.Label>First Message</Form.Label>
                                                <Form.Control name='firstmessage' placeholder={placeholders.firstmessage} value={formdata.firstmessage} onChange={(e) => handlefieldvalue('firstmessage', e.target.value)} type="text" />
                                            </Form.Group>
                                        </Col>
                                      
                                    </Row>
                                </Tab.Pane>
                            <Tab.Pane eventKey="Knowledge Base">
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Knowledge Base Files</Form.Label>
                                            <Form.Control name='file' ref={fileRef} placeholder={placeholders.file} type="file" multiple onChange={handleFilesChange} />
                                                {selectedFiles.length > 0 && (
                                                    <div className="mt-2">
                                                        <ul style={{ margin: 0, paddingLeft: '18px' }}>
                                                            {selectedFiles.map((f, i) => (
                                                                <li key={i}>{f.name} ({Math.round(f.size/1024)} KB)</li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}

                                                {agentFiles.length > 0 && (
                                                    <div className="mt-2">
                                                        <strong>Uploaded Files:</strong>
                                                        <ul style={{ margin: 0, paddingLeft: '18px' }}>
                                                            {agentFiles.map((f, i) => (
                                                                                                                        <li key={i} className="d-flex align-items-center" style={{justifyContent: 'flex-start', gap: '0.5rem'}}>
                                                                                                                                <span style={{flexGrow:1}}>{f.name} ({Math.round(f.size/1024)} KB)</span>
                                                                                                                                <Button size="sm" variant="link" onClick={() => deleteAgentFile(f.name)} title={`Delete ${f.name}`} style={{padding:'0.15rem', color:'#dc3545'}}>
                                                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle" viewBox="0 0 16 16">
                                                                                                                                            <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"/>
                                                                                                                                            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                                                                                                                                        </svg>
                                                                                                                                </Button>
                                                                                                                        </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Actions">
                                <Row>
                                    <Col>
                                        <div className="mb-3 mt-2">
                                            <Form.Check 
                                                type="switch"
                                                id="enable-calendar-switch"
                                                label="Enable calendar integration for this agent"
                                                checked={!!formdata.enable_calendar}
                                                onChange={(e) => handlefieldvalue('enable_calendar', e.target.checked)}
                                            />
                                            {!!formdata.enable_calendar && (
                                                <div className="mt-3 p-3" style={{border: '1px solid #ddd', borderRadius: '4px'}}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Cal.com Username</Form.Label>
                                                        <Form.Control 
                                                            name='cal_username' 
                                                            placeholder="e.g. john-doe" 
                                                            value={formdata.cal_username || ''} 
                                                            onChange={(e) => handlefieldvalue('cal_username', e.target.value)} 
                                                            type="text" 
                                                        />
                                                    </Form.Group>
                                                    <Form.Group className="mb-0">
                                                        <Form.Label>Event Type Slug</Form.Label>
                                                        <Form.Control 
                                                            name='cal_event_type_slug' 
                                                            placeholder="e.g. 15min" 
                                                            value={formdata.cal_event_type_slug || ''} 
                                                            onChange={(e) => handlefieldvalue('cal_event_type_slug', e.target.value)} 
                                                            type="text" 
                                                        />
                                                    </Form.Group>
                                                </div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="Intent Responses">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <small className="text-muted">Fixed replies for common user intents — bypass LLM for faster, predictable calls.</small>
                                    {props.modifymode && <Button size="sm" variant="outline-primary" onClick={addIntentRow}>+ Add Intent</Button>}
                                </div>
                                {!props.modifymode ? (
                                    <div className="text-muted text-center mt-4">Save the agent first to configure intent responses.</div>
                                ) : (
                                    <div style={{overflowY:'auto', maxHeight:'390px'}}>
                                        <table className="table table-sm table-bordered" style={{fontSize:'0.85rem'}}>
                                            <thead className="table-light">
                                                <tr>
                                                    <th style={{width:'18%'}}>Intent</th>
                                                    <th style={{width:'28%'}}>Trigger Pattern (regex)</th>
                                                    <th style={{width:'42%'}}>Response</th>
                                                    <th style={{width:'7%',textAlign:'center'}}>On</th>
                                                    <th style={{width:'5%'}}></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {intentRows.map((row, idx) => (
                                                    <tr key={idx}>
                                                        <td>
                                                            <Form.Control as="select" size="sm" value={row.intent} onChange={e => updateIntentRow(idx, 'intent', e.target.value)}>
                                                                <option value="">Select...</option>
                                                                {Object.entries(INTENT_LABELS).map(([k, v]) => (
                                                                    <option key={k} value={k}>{v}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </td>
                                                        <td>
                                                            <Form.Control size="sm" value={row.pattern} onChange={e => updateIntentRow(idx, 'pattern', e.target.value)} placeholder={DEFAULT_PATTERNS[row.intent] || 'regex pattern'} />
                                                        </td>
                                                        <td>
                                                            <Form.Control size="sm" value={row.response} onChange={e => updateIntentRow(idx, 'response', e.target.value)} placeholder="Response text" />
                                                        </td>
                                                        <td className="text-center" style={{verticalAlign:'middle'}}>
                                                            <Form.Check type="switch" checked={!!row.is_active} onChange={e => updateIntentRow(idx, 'is_active', e.target.checked ? 1 : 0)} />
                                                        </td>
                                                        <td style={{verticalAlign:'middle'}}>
                                                            <Button size="sm" variant="link" style={{color:'#dc3545',padding:0}} onClick={() => removeIntentRow(idx)}>✕</Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                                {intentRows.length === 0 && (
                                                    <tr><td colSpan={5} className="text-muted text-center">No intent responses configured. Click "+ Add Intent" to add one.</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </Tab.Pane>
                            
                        </Tab.Content>

                    </Tab.Container>
                    <div className='p-2 d-flex justify-content-end'>
                        <Button type="reset" className='mx-1' variant="secondary"  >
                            Cancel
                        </Button>
                        <Button type="submit" className={`mx-1`} title={props.modifymode ? 'Modify this Agent' : 'Create new Agent'} variant="primary" >
                            Save
                        </Button>
                    </div>
                </Form>
            </Container>
        </>
    )
}

export default AForm